import React, { useState } from "react";
import styled from "styled-components";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { isMobile } from "react-device-detect";

const ActionAccordionDesktop = ({
  firstRowButtons,
  secondRowButtons,
  style,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    !isMobile && (
      <AccordionContainer
        style={{
          width: "100%",
          ...style?.buttonContainer,
          position: "relative",
        }}
      >
        {(firstRowButtons.length > 0 || secondRowButtons.length > 0) && (
          <>
            <AccordionContent>
              {/* First Row: Always Visible */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "9px",
                  flex: 1,
                  paddingLeft: secondRowButtons.length > 0 ? "40px" : "0", // Account for toggle button
                  minHeight: "40px",
                  alignItems: "center",
                }}
              >
                {firstRowButtons.map((button, index) => { 
                  if (button && typeof button.key !== "undefined") { /* KAD added to hide missing buttons Sept 23, 2025 */
                      return(<div key={index} className="action-button">
                        {button}
                      </div>
                    );
                  } else {
                    // console.log("not displaying button " + button.name);
                  }
                })}
              </div>
              {/* Toggle Button for Second Row */}
              {secondRowButtons.length > 0 && (
                <div
                  className="toggle-container"
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "0",
                    zIndex: 1000,
                    background: "rgba(255, 255, 255, 0.9)",
                    padding: "6px",
                    borderRadius: "50%",
                  }}
                  onClick={handleToggle}
                >
                  <FaChevronUp
                    style={{
                      cursor: "pointer",
                      display: isOpen ? "block" : "none",
                      fontSize: "18px",
                      color: "#333",
                    }}
                  />
                  <FaChevronDown
                    style={{
                      cursor: "pointer",
                      display: !isOpen ? "block" : "none",
                      fontSize: "18px",
                      color: "#333",
                    }}
                  />
                </div>
              )}
            </AccordionContent>
            {/* Second Row: Collapsible */}
            {isOpen && secondRowButtons.length > 0 && (
              <AccordionContent>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "9px",
                    flex: 1,
                    paddingLeft: "0",
                    minHeight: "40px",
                    alignItems: "center",
                  }}
                >
                  {secondRowButtons.map((button, index) => (
                    <div key={index} className="action-button">
                      {button}
                    </div>
                  ))}
                </div>
              </AccordionContent>
            )}
          </>
        )}
      </AccordionContainer>
    )
  );
};

// Styled components
const AccordionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  min-height: 40px;
  position: relative;
  overflow: visible;
`;

const AccordionContent = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px 0;
  background: transparent;
  border: none;
  margin-top: 0;
`;

export default ActionAccordionDesktop;
